module.exports = __webpack_public_path__ + "static/Group-2-92eefea6b6bd54652a3cca3612713292.png";